<template>
    <div class="card p-3 rounded-more d-flex flex-column gap user-select-none">
        <div class="d-flex flex-row gap-0.5">
            <div class="rect"></div>
            <h4 class="text-md text-bold">Deposit Collected</h4>
        </div>
        <div class="d-flex flex-row gap justify-content-end align-items-center">
            <div class="text-xl text-bold">{{ currency }} {{ total }}</div>
        </div>
    </div>
</template>
<script>
export default {
    name : "DepositCollectedCard",
    props: {
        total : {
            type : Number,
            default : 0
        },
        currency : {
            type : String,
            default : ""
        }
    }
}
</script>